import {DependencyList, useEffect} from 'react';
import Util from '../util/util';
import afterFrame from 'afterframe';

const useMeasureRender = (componentName: string, metricName: string, deps: DependencyList = []): void => {
	useEffect(() => {
		const startTime = performance.now();

		afterFrame(() => {
			const duration = performance.now() - startTime;
			Util.storeCustomMetric(componentName, metricName, duration);
		});
	}, deps);
};

export default useMeasureRender;
